import { useSearchParams } from "next/navigation";
import { QUERY_URL_PARAM } from "@/components/Search/constants";
import { useOfferingsSearchCount } from "@/components/Search/hooks/useOfferingsSearchCount";
import { ResultsHeadingVariant } from "@/components/Search/types";
import useTranslations from "@/i18n/useTranslations";

interface ResultsHeadingProps {
  resultsTitle?: string;
  className?: string;
  offeringsSearchParams?: string;
  resultsCount?: number;
  resultsHeadingVariant?: ResultsHeadingVariant;
}

const DynamicResultsHeading = ({
  resultsTitle,
  className,
  offeringsSearchParams = "",
  resultsCount,
  resultsHeadingVariant = "count-with-query",
}: ResultsHeadingProps) => {
  const t = useTranslations("Search");
  const searchParams = useSearchParams();
  const queryParam = searchParams.get(QUERY_URL_PARAM);
  const queryResultsLabel = resultsTitle ? resultsTitle : queryParam;

  const { numberOfHits: apiCount } = useOfferingsSearchCount(
    offeringsSearchParams,
  );
  const numberOfHits = resultsCount ?? apiCount;
  const showQuery = resultsHeadingVariant !== "count-only";

  return (
    <h2 className={"text-2xl " + className}>
      {showQuery && queryResultsLabel
        ? t("resultsCountWithQuery", {
            count: numberOfHits,
            query: queryResultsLabel,
          })
        : t("resultsCount", { count: numberOfHits })}
    </h2>
  );
};

export default DynamicResultsHeading;
